import { render, staticRenderFns } from "./OptIn.vue?vue&type=template&id=fe7eb75e&"
import script from "./OptIn.vue?vue&type=script&lang=js&"
export * from "./OptIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports